import IntroScene from '../scenes/intro-scene';
import CodeTypingScene from '../scenes/code-typing-scene';
import BuildScene from '../scenes/build-scene';
import ConsoleScene from '../scenes/console-scene';
import HighlightScene from '../scenes/highlight-scene';
import ErrorScene from '../scenes/error-scene';
import FileSwitchScene from '../scenes/file-switch-scene';
import MenuActionScene from '../scenes/menu-action-scene';

const SCENE_COMPONENTS = {
  'intro': IntroScene,
  'code-typing': CodeTypingScene,
  'build': BuildScene,
  'console': ConsoleScene,
  'highlight': HighlightScene,
  'error': ErrorScene,
  'file-switch': FileSwitchScene,
  'menu-action': MenuActionScene,
};

export default function SceneRenderer({ scene, projectName, fps }) {
  const Component = SCENE_COMPONENTS[scene.type];
  if (!Component) {
    return (
      <div style={{
        width: '100%', height: '100%', display: 'flex',
        alignItems: 'center', justifyContent: 'center',
        background: '#1e1e1e', color: '#F44747', fontSize: 24,
      }}>
        Unknown scene type: {scene.type}
      </div>
    );
  }
  return <Component {...scene} projectName={projectName} fps={fps} />;
}
